// Sidebar.jsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../cstm.style.css";

export default function Sidebar({ onLogout }) {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const [openMenu, setOpenMenu] = useState({
    loans: false,
    dealx: false,
  });

  const toggleMenu = (menu) => {
    setOpenMenu((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
        <h4 className="sidebar-logo">UTC Finance</h4>
      </div>

      {/* Main nav section */}
      <ul className="sidebar-nav">
        {/* Home */}
        <li className="sidebar-nav-item">
          <Link
            to="/"
            className={
              isActive("/") ? "sidebar-btn sidebar-btn-active" : "sidebar-btn"
            }
          >
            Home
          </Link>
        </li>

        {/* Loans Menu */}
        <li className="sidebar-nav-item">
          <button
            className="sidebar-btn sidebar-btn-toggle"
            type="button"
            onClick={() => toggleMenu("loans")}
          >
            <span>Loans</span>
            <span className="sidebar-toggle-icon">
              {openMenu.loans ? "▲" : "▼"}
            </span>
          </button>

          {openMenu.loans && (
            <ul className="sidebar-submenu">
              <li className="sidebar-submenu-item">
                <Link
                  to="/loans/others"
                  className={
                    isActive("/loans/others")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Girevance
                </Link>
              </li>
              <li className="sidebar-submenu-item">
                <Link
                  to="/loans/webleads"
                  className={
                    isActive("/loans/webleads")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Website Leads
                </Link>
              </li>
            </ul>
          )}
        </li>

        {/* DealX Menu */}
        <li className="sidebar-nav-item">
          <button
            className="sidebar-btn sidebar-btn-toggle"
            type="button"
            onClick={() => toggleMenu("dealx")}
          >
            <span>DealX</span>
            <span className="sidebar-toggle-icon">
              {openMenu.dealx ? "▲" : "▼"}
            </span>
          </button>

          {openMenu.dealx && (
            <ul className="sidebar-submenu">
              <li className="sidebar-submenu-item">
                <Link
                  to="/dealx/dashboard"
                  className={
                    isActive("/dealx/dashboard")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Dashboard
                </Link>
              </li>
              <li className="sidebar-submenu-item">
                <Link
                  to="/dealx/retail-partners"
                  className={
                    isActive("/dealx/retail-partners")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Retail Partners
                </Link>
              </li>
              <li className="sidebar-submenu-item">
                <Link
                  to="/dealx/reports"
                  className={
                    isActive("/dealx/reports")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Reports
                </Link>
              </li>
              <li className="sidebar-submenu-item">
                <Link
                  to="/dealx/agents"
                  className={
                    isActive("/dealx/agents")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Agents
                </Link>
              </li>
              <li className="sidebar-submenu-item">
                <Link
                  to="/dealx/customers"
                  className={
                    isActive("/dealx/customers")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Customers
                </Link>
              </li>
              <li className="sidebar-submenu-item">
                <Link
                  to="/dealx/loan-book"
                  className={
                    isActive("/dealx/loan-book")
                      ? "sidebar-link sidebar-link-active"
                      : "sidebar-link"
                  }
                >
                  Loan Book
                </Link>
              </li>
            </ul>
          )}
        </li>

        {/* Contact */}
        <li className="sidebar-nav-item">
          <Link
            to="/contact-us"
            className={
              isActive("/contact-us")
                ? "sidebar-btn sidebar-btn-active"
                : "sidebar-btn"
            }
          >
            Contact Us
          </Link>
        </li>
      </ul>

      {/* Bottom section for Logout */}
      <div className="sidebar-bottom">
      <button
          type="button"
          className="sidebar-btn"
          onClick={onLogout}
        >
          Log Out
        </button>
      </div>
    </div>
  );
}
